import { Navigate, useLocation } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';

import { auth } from 'src/services/firebase-service';
import logging from 'src/services/logging';

import { Backdrop, CircularProgress } from '@mui/material';

interface Props {
  children: React.ReactNode;
}

const AuthRoute = ({ children }: Props) => {
  const [user, loading, error] = useAuthState(auth);
  const location = useLocation();

  if (error) {
    logging.error(error, 'AuthRoute');
  }

  logging.info(`Loading: ${loading}`, 'AuthRoute');
  if (loading) {
    return (
      <Backdrop open={loading}>
        <CircularProgress color='inherit' />
      </Backdrop>
    );
  }

  if (!user) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    logging.warn('No user detected, redirecting.', 'AuthRoute');
    if (location.pathname === '/logout') {
      return <Navigate to='/login' />;
    }
    return <Navigate to='/login' state={{ from: location }} replace />;
  }
  logging.info('Show children...', 'AuthRoute');
  return <>{children}</>;
};

export default AuthRoute;
